module.exports = __webpack_public_path__ + "img/img (42).16660176.png";